import { TradeListItem } from 'app/models/trade-list-params'
import * as types from './types'

export const getTradeList = (payload: TradeListItem[]) => ({
  type: types.GET_TRADE_LIST,
  payload,
})

export const startLoadingTradeList = () => ({
  type: types.START_LOADING_TRADE_LIST,
})

export const stopLoadingTradeList = () => ({
  type: types.STOP_LOADING_TRADE_LIST,
})
